/**
 * File generated by the Figma Token Engine
 * Do not edit directly
 */

export const BORDER_RADIUS_TOOLTIP_DEFAULT = "0.25rem";
export const BORDER_RADIUS_POPOVER_DEFAULT = "0.5rem";
export const BORDER_RADIUS_TAG_SM = "0.25rem";
export const BORDER_RADIUS_TAG_XL = "62.4rem";
export const BORDER_RADIUS_BUTTON_SM = "0.25rem";
export const BORDER_RADIUS_BUTTON_FULL = "62.4rem";
export const BORDER_RADIUS_INPUT_SM = "0.25rem";
export const BORDER_RADIUS_INPUT_LG = "0.5rem";
export const BORDER_RADIUS_CARD_SM = "0.25rem";
export const BORDER_RADIUS_CARD_MD = "0.5rem";
export const BORDER_RADIUS_CARD_LG = "0.75rem";
export const BORDER_RADIUS_MODAL_LG = "0.75rem";
export const BORDER_RADIUS_MODAL_XL = "1rem";
export const BORDER_RADIUS_NONE = 0;
export const BORDER_RADIUS_XS = "0.25rem";
export const BORDER_RADIUS_SM = "0.5rem";
export const BORDER_RADIUS_MD = "0.75rem";
export const BORDER_RADIUS_LG = "1rem";
export const BORDER_RADIUS_XL = "1.25rem";
export const BORDER_RADIUS_2XL = "1.5rem";
export const BORDER_RADIUS_3XL = "1.75rem";
export const BORDER_RADIUS_FULL = "62.4rem";
export const BORDER_WIDTH_BUTTON_DEFAULT = "0.0625rem";
export const BORDER_WIDTH_BUTTON_HOVER = "0.125rem";
export const BORDER_WIDTH_BUTTON_PRESSED = "0.125rem";
export const BORDER_WIDTH_INPUT_DEFAULT = "0.0625rem";
export const BORDER_WIDTH_INPUT_FOCUS = "0.125rem";
export const BORDER_WIDTH_INPUT_ERROR = "0.125rem";
export const BORDER_WIDTH_CARD_DEFAULT = "0.0625rem";
export const BORDER_WIDTH_CARD_HOVER = "0.125rem";
export const BORDER_WIDTH_NONE = 0;
export const BORDER_WIDTH_XS = "0.0625rem";
export const BORDER_WIDTH_SM = "0.125rem";
export const BORDER_WIDTH_MD = "0.25rem";
export const BORDER_GREEN = "#00df88";
export const BORDER_BLUE = "#0053e2";
export const BORDER_YELLOW = "#f4b400";
export const BORDER_RED = "#a90000";
export const BORDER_DARK = "#111";
export const BORDER_LIGHT = "#e2e2e2";
export const BORDER_LIGHTER = "#f1f1f1";
export const LAYOUT_SPACING_INLINE_NONE = 0;
export const LAYOUT_SPACING_INLINE_3XS = "0.125rem";
export const LAYOUT_SPACING_INLINE_2XS = "0.25rem";
export const LAYOUT_SPACING_INLINE_XS = "0.5rem";
export const LAYOUT_SPACING_INLINE_SM = "0.75rem";
export const LAYOUT_SPACING_INLINE_MD = "1rem";
export const LAYOUT_SPACING_INLINE_LG = "2rem";
export const LAYOUT_SPACING_INLINE_XL = "2.5rem";
export const LAYOUT_SPACING_INLINE_2XL = "5rem";
export const LAYOUT_SPACING_STACK_NONE = 0;
export const LAYOUT_SPACING_STACK_3XS = "0.125rem";
export const LAYOUT_SPACING_STACK_2XS = "0.25rem";
export const LAYOUT_SPACING_STACK_XS = "0.5rem";
export const LAYOUT_SPACING_STACK_SM = "0.75rem";
export const LAYOUT_SPACING_STACK_MD = "1rem";
export const LAYOUT_SPACING_STACK_LG = "2rem";
export const LAYOUT_SPACING_STACK_XL = "2.5rem";
export const LAYOUT_SPACING_STACK_2XL = "5rem";
export const SECTION_SPACING_SM = "1.5rem";
export const SECTION_SPACING_MD = "1.75rem";
export const SECTION_SPACING_LG = "2rem";
export const SECTION_SPACING_XL = "2.5rem";
export const SECTION_SPACING_2XL = "3.5rem";
export const SECTION_SPACING_3XL = "5rem";
export const COMPONENT_CARD_SM = "0.75rem";
export const COMPONENT_CARD_MD = "1.25rem";
export const COMPONENT_CARD_LG = "1.5rem";
export const COMPONENT_CARD_XL = "2rem";
export const COMPONENT_CARD_2XL = "2.5rem";
export const COMPONENT_MODAL_SM = "1.25rem";
export const COMPONENT_MODAL_MD = "1.5rem";
export const COMPONENT_MODAL_LG = "1.75rem";
export const SPACE_0 = 0;
export const SPACE_3XS = "0.125rem";
export const SPACE_2XS = "0.25rem";
export const SPACE_XS = "0.5rem";
export const SPACE_SM = "0.75rem";
export const SPACE_MD = "1rem";
export const SPACE_LG = "1.25rem";
export const SPACE_XL = "1.5rem";
export const SPACE_2XL = "1.75rem";
export const SPACE_3XL = "2rem";
export const SPACE_4XL = "2.5rem";
export const SPACE_5XL = "3rem";
export const SPACE_6XL = "3.5rem";
export const SPACE_7XL = "4rem";
export const SPACE_8XL = "5rem";
export const XS = "0.75rem";
export const S = "1rem";
export const MD = "1.25rem";
export const LG = "1.5rem";
export const XL = "1.75rem";
export const XXL = "2rem";
export const BACKGROUND_YELLOW_LIGHT = "#fff5d9";
export const BACKGROUND_YELLOW_MEDIUM = "#ffe7a5";
export const BACKGROUND_BLUE_LIGHT = "#e3ebff";
export const BACKGROUND_BLUE_MEDIUM = "#c3deff";
export const BACKGROUND_GREEN_LIGHT = "#E5FCF3";
export const BACKGROUND_GREEN_MEDIUM = "#ccf9e7";
export const BACKGROUND_GREEN_DARK = "#00df88";
export const BACKGROUND_RED_LIGHT = "#feecec";
export const BACKGROUND_RED_MEDIUM = "#fed8d8";
export const BACKGROUND_WHITE_LIGHT = "#ffffff";
export const BACKGROUND_NEUTRAL_DARK = "#111";
export const BACKGROUND_NEUTRAL_GREY = "#e2e2e2";
export const BACKGROUND_NEUTRAL_LIGHT = "#f1f1f1";
export const TEXT_INVERSE = "#ffffff";
export const TEXT_DISABLED = "#ababab";
export const TEXT_PLACEHOLDER = "#919191";
export const TEXT_TERTIARY = "#525252";
export const TEXT_BODY = "#3b3b3b";
export const TEXT_HEADER = "#111";
export const TEXT_GREEN = "#00df88";
export const TEXT_BLUE = "#0053e2";
export const TEXT_ERROR = "#a90000";
export const TEXT_YELLOW = "#f4b400";
export const FEEDBACK_ALERT_SUCCESS = "#00df88";
export const FEEDBACK_ALERT_ERROR = "#a90000";
export const FEEDBACK_ALERT_WARNING = "#fff5d9";
export const FEEDBACK_ALERT_NEUTRAL = "#111";
export const ACTION_PRIMARY_DEFAULT = "#00df88";
export const ACTION_PRIMARY_HOVER = "#4ce9ac";
export const ACTION_PRIMARY_ACTIVE = "#98f2cf";
export const ACTION_PRIMARY_DISABLED = "#E5FCF3";
export const ACTION_SECONDARY_DEFAULT = "#0053e2";
export const ACTION_SECONDARY_HOVER = "#254cac";
export const ACTION_SECONDARY_ACTIVE = "#9ec1ff";
export const ACTION_SECONDARY_DISABLED = "#e3ebff";
export const ACTION_DESTRUCTIVE_DEFAULT = "#d60000";
export const ACTION_DESTRUCTIVE_HOVER = "#a90000";
export const ACTION_DESTRUCTIVE_ACTIVE = "#fed8d8";
export const ACTION_DESTRUCTIVE_DISABLE = "#feecec";
export const ACTION_TERTIARY_DEFAULT = "#3b3b3b";
export const ACTION_TERTIARY_HOVER = "#111";
export const ACTION_TERTIARY_ACTIVE = "#ababab";
export const ACTION_TERTIARY_DISABLE = "#f1f1f1";
export const ICON_YELLOW = "#f4b400";
export const ICON_BLUE = "#0053e2";
export const ICON_GREEN = "#00df88";
export const ICON_RED = "#a90000";
export const ICON_NEUTRAL = "#111";
export const ICON_LIGHT = "#e2e2e2";
export const ICON_LIGHTER = "#f1f1f1";
export const GREEN_10 = "#E5FCF3";
export const GREEN_20 = "#ccf9e7";
export const GREEN_30 = "#B2F5DB";
export const GREEN_40 = "#98f2cf";
export const GREEN_50 = "#81efc3";
export const GREEN_60 = "#66ecb8";
export const GREEN_70 = "#4ce9ac";
export const GREEN_80 = "#31e5a0";
export const GREEN_90 = "#1ae294";
export const GREEN_100 = "#00df88";
export const NEUTRAL_10 = "#f1f1f1";
export const NEUTRAL_20 = "#e2e2e2";
export const NEUTRAL_30 = "#c6c6c6";
export const NEUTRAL_40 = "#ababab";
export const NEUTRAL_50 = "#919191";
export const NEUTRAL_60 = "#6a6a6a";
export const NEUTRAL_70 = "#525252";
export const NEUTRAL_80 = "#3b3b3b";
export const NEUTRAL_90 = "#262626";
export const NEUTRAL_100 = "#111";
export const BLUE_10 = "#e3ebff";
export const BLUE_20 = "#c3deff";
export const BLUE_30 = "#9ec1ff";
export const BLUE_40 = "#5c83fd";
export const BLUE_50 = "#446ef5";
export const BLUE_60 = "#0053e2";
export const BLUE_70 = "#254cac";
export const BLUE_80 = "#14328d";
export const BLUE_90 = "#0c285f";
export const BLUE_100 = "#071e3c";
export const RED_10 = "#feecec";
export const RED_20 = "#fed8d8";
export const RED_30 = "#feb3b3";
export const RED_40 = "#fe8888";
export const RED_50 = "#fb5959";
export const RED_60 = "#d60000";
export const RED_70 = "#a90000";
export const RED_80 = "#820000";
export const RED_90 = "#550000";
export const RED_100 = "#3a0000";
export const YELLOW_10 = "#fff5d9";
export const YELLOW_20 = "#ffe7a5";
export const YELLOW_30 = "#ffd86b";
export const YELLOW_40 = "#ffce46";
export const YELLOW_50 = "#ffc420";
export const YELLOW_60 = "#f4b400";
export const YELLOW_70 = "#dba200";
export const YELLOW_80 = "#c69200";
export const YELLOW_90 = "#b38400";
export const YELLOW_100 = "#9a7100";
export const WHITE_10 = "#ffffff";
export const DISPLAY_2XL_FONT_FAMILY = "Campton";
export const DISPLAY_2XL_FONT_WEIGHT = 500;
export const DISPLAY_2XL_LINE_HEIGHT = "56px";
export const DISPLAY_2XL_FONT_SIZE = "52px";
export const DISPLAY_2XL_LETTER_SPACING = "0%";
export const DISPLAY_2XL_PARAGRAPH_INDENT = "0px";
export const DISPLAY_2XL_TEXT_CASE = "none";
export const DISPLAY_2XL_TEXT_DECORATION = "none";
export const DISPLAY_XL_FONT_FAMILY = "Campton";
export const DISPLAY_XL_FONT_WEIGHT = 500;
export const DISPLAY_XL_LINE_HEIGHT = "48px";
export const DISPLAY_XL_FONT_SIZE = "44px";
export const DISPLAY_XL_LETTER_SPACING = "0%";
export const DISPLAY_XL_PARAGRAPH_INDENT = "0px";
export const DISPLAY_XL_TEXT_CASE = "none";
export const DISPLAY_XL_TEXT_DECORATION = "none";
export const HEADING_XL_FONT_FAMILY = "Campton";
export const HEADING_XL_FONT_WEIGHT = 600;
export const HEADING_XL_LINE_HEIGHT = "48px";
export const HEADING_XL_FONT_SIZE = "40px";
export const HEADING_XL_LETTER_SPACING = "0%";
export const HEADING_XL_PARAGRAPH_INDENT = "0px";
export const HEADING_XL_TEXT_CASE = "none";
export const HEADING_XL_TEXT_DECORATION = "none";
export const HEADING_LG_FONT_FAMILY = "Campton";
export const HEADING_LG_FONT_WEIGHT = 600;
export const HEADING_LG_LINE_HEIGHT = "44px";
export const HEADING_LG_FONT_SIZE = "36px";
export const HEADING_LG_LETTER_SPACING = "0%";
export const HEADING_LG_PARAGRAPH_INDENT = "0px";
export const HEADING_LG_TEXT_CASE = "none";
export const HEADING_LG_TEXT_DECORATION = "none";
export const HEADING_MD_FONT_FAMILY = "Campton";
export const HEADING_MD_FONT_WEIGHT = 600;
export const HEADING_MD_LINE_HEIGHT = "40px";
export const HEADING_MD_FONT_SIZE = "32px";
export const HEADING_MD_LETTER_SPACING = "0%";
export const HEADING_MD_PARAGRAPH_INDENT = "0px";
export const HEADING_MD_TEXT_CASE = "none";
export const HEADING_MD_TEXT_DECORATION = "none";
export const HEADING_SM_FONT_FAMILY = "Campton";
export const HEADING_SM_FONT_WEIGHT = 600;
export const HEADING_SM_LINE_HEIGHT = "36px";
export const HEADING_SM_FONT_SIZE = "28px";
export const HEADING_SM_LETTER_SPACING = "0%";
export const HEADING_SM_PARAGRAPH_INDENT = "0px";
export const HEADING_SM_TEXT_CASE = "none";
export const HEADING_SM_TEXT_DECORATION = "none";
export const HEADING_XS_FONT_FAMILY = "Campton";
export const HEADING_XS_FONT_WEIGHT = 600;
export const HEADING_XS_LINE_HEIGHT = "28px";
export const HEADING_XS_FONT_SIZE = "20px";
export const HEADING_XS_LETTER_SPACING = "0%";
export const HEADING_XS_PARAGRAPH_INDENT = "0px";
export const HEADING_XS_TEXT_CASE = "none";
export const HEADING_XS_TEXT_DECORATION = "none";
export const HEADING_2XS_FONT_FAMILY = "Campton";
export const HEADING_2XS_FONT_WEIGHT = 600;
export const HEADING_2XS_LINE_HEIGHT = "24px";
export const HEADING_2XS_FONT_SIZE = "18px";
export const HEADING_2XS_LETTER_SPACING = "0%";
export const HEADING_2XS_PARAGRAPH_INDENT = "0px";
export const HEADING_2XS_TEXT_CASE = "none";
export const HEADING_2XS_TEXT_DECORATION = "none";
export const BODY_XL_FONT_FAMILY = "Campton";
export const BODY_XL_FONT_WEIGHT = "book";
export const BODY_XL_LINE_HEIGHT = "28px";
export const BODY_XL_FONT_SIZE = "18px";
export const BODY_XL_LETTER_SPACING = "0%";
export const BODY_XL_PARAGRAPH_INDENT = "0px";
export const BODY_XL_TEXT_CASE = "none";
export const BODY_XL_TEXT_DECORATION = "none";
export const BODY_LG_FONT_FAMILY = "Campton";
export const BODY_LG_FONT_WEIGHT = "book";
export const BODY_LG_LINE_HEIGHT = "24px";
export const BODY_LG_FONT_SIZE = "16px";
export const BODY_LG_LETTER_SPACING = "0%";
export const BODY_LG_PARAGRAPH_INDENT = "0px";
export const BODY_LG_TEXT_CASE = "none";
export const BODY_LG_TEXT_DECORATION = "none";
export const BODY_MD_FONT_FAMILY = "Campton";
export const BODY_MD_FONT_WEIGHT = "book";
export const BODY_MD_LINE_HEIGHT = "20px";
export const BODY_MD_FONT_SIZE = "14px";
export const BODY_MD_LETTER_SPACING = "0%";
export const BODY_MD_PARAGRAPH_INDENT = "0px";
export const BODY_MD_TEXT_CASE = "none";
export const BODY_MD_TEXT_DECORATION = "none";
export const BODY_SM_FONT_FAMILY = "Campton";
export const BODY_SM_FONT_WEIGHT = "book";
export const BODY_SM_LINE_HEIGHT = "20px";
export const BODY_SM_FONT_SIZE = "12px";
export const BODY_SM_LETTER_SPACING = "0%";
export const BODY_SM_PARAGRAPH_INDENT = "0px";
export const BODY_SM_TEXT_CASE = "none";
export const BODY_SM_TEXT_DECORATION = "none";
export const UTILITY_BUTTON_FONT_FAMILY = "Campton";
export const UTILITY_BUTTON_FONT_WEIGHT = 500;
export const UTILITY_BUTTON_LINE_HEIGHT = "16px";
export const UTILITY_BUTTON_FONT_SIZE = "16px";
export const UTILITY_BUTTON_LETTER_SPACING = "0%";
export const UTILITY_BUTTON_PARAGRAPH_INDENT = "0px";
export const UTILITY_BUTTON_TEXT_CASE = "none";
export const UTILITY_BUTTON_TEXT_DECORATION = "none";
export const UTILITY_LINK_FONT_FAMILY = "Campton";
export const UTILITY_LINK_FONT_WEIGHT = 500;
export const UTILITY_LINK_LINE_HEIGHT = "20px";
export const UTILITY_LINK_FONT_SIZE = "14px";
export const UTILITY_LINK_LETTER_SPACING = "0%";
export const UTILITY_LINK_PARAGRAPH_INDENT = "0px";
export const UTILITY_LINK_TEXT_CASE = "none";
export const UTILITY_LINK_TEXT_DECORATION = "underline";
export const UTILITY_CAPTION_FONT_FAMILY = "Campton";
export const UTILITY_CAPTION_FONT_WEIGHT = "book";
export const UTILITY_CAPTION_LINE_HEIGHT = "16px";
export const UTILITY_CAPTION_FONT_SIZE = "12px";
export const UTILITY_CAPTION_LETTER_SPACING = "0%";
export const UTILITY_CAPTION_PARAGRAPH_INDENT = "0px";
export const UTILITY_CAPTION_TEXT_CASE = "none";
export const UTILITY_CAPTION_TEXT_DECORATION = "none";
export const FONT_FAMILIES_CAMPTON = "Campton";
export const LINE_HEIGHT_6XL = "56px";
export const LINE_HEIGHT_5XL = "48px";
export const LINE_HEIGHT_4XL = "44px";
export const LINE_HEIGHT_3XL = "40px";
export const LINE_HEIGHT_2XL = "36px";
export const LINE_HEIGHT_XL = "32px";
export const LINE_HEIGHT_LG = "28px";
export const LINE_HEIGHT_MD = "24px";
export const LINE_HEIGHT_S = "20px";
export const LINE_HEIGHT_XS = "16px";
export const MEDIUM = 500;
export const SEMI_BOLD = 600;
export const BOOK = "book";
export const FONT_SIZE_2XS = "14px";
export const FONT_SIZE_3XS = "12px";
export const FONT_SIZE_XS = "16px";
export const FONT_SIZE_MD = "18px";
export const FONT_SIZE_LG = "20px";
export const FONT_SIZE_XL = "28px";
export const FONT_SIZE_2XL = "32px";
export const FONT_SIZE_3XL = "36px";
export const FONT_SIZE_4XL = "40px";
export const FONT_SIZE_5XL = "44px";
export const FONT_SIZE_6XL = "52px";
export const LETTER_SPACING_0 = "0%";
export const TEXT_CASE_NONE = "none";
export const TEXT_DECORATION_NONE = "none";
export const TEXT_DECORATION_UNDERLINE = "underline";
export const PARAGRAPH_INDENT_0 = "0px";
